export default __webpack_public_path__ + "static/media/10.038f224b.jpg";